// extracted by mini-css-extract-plugin
export var label = "_du-2";
export var slideContainer = "_du-0";
export var slider = "_du-1";